import React from 'react';
import { Link } from 'react-router-dom';
import '../css/footer.css';

const Footer = ({ topMargin }) => {
  return (
    <div className="footer-container">
      <span className="copyright-text">
        &copy; {new Date().getFullYear()} SquadBot.
      </span>
    </div>
  );
};

export default Footer;
